import React, { useState, useEffect } from "react";
import "./account.scss";
import {  useNavigate } from "react-router-dom";

const Account = ({ handleLogout }) => {
  const [userName, setUserName] = useState("Guest");
  const [showDropdown, setShowDropdown] = useState(false);

  const navigator = useNavigate();

  useEffect(() => {
    const userInfo = localStorage.getItem("FWUser");
    if (userInfo) {
      try {
        const parsedUser = JSON.parse(userInfo);
        setUserName(parsedUser.Information.Name || "User");
      } catch {
        setUserName("User");
      }
    } else {
      setUserName("Guest");
    }
  }, []);

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleOptionClick = (option) => {
    if (option === "logout") {
      handleLogout();
    } else {
      console.log(`Navigating to ${option}`);
      // Add navigation logic here if needed
      navigator(`/${option}`);
    }
    setShowDropdown(false); // Close dropdown after selection
  };

  return (
    <div className="accountDiv flex">
      <button className="accountButton flex" onClick={toggleDropdown}>
        <i className="fa fa-user" aria-hidden="true"></i>
        <span className="userName">{userName}</span>
        <i className={`fa fa-angle-down ${showDropdown ? "open" : ""}`} aria-hidden="true"></i>
      </button>
      {showDropdown && (
        <div className="dropdownMenu">
          <div className="dropdownItem" onClick={() => handleOptionClick("profiles")}>
            <i className="fa fa-user-circle" aria-hidden="true"></i> Profile
          </div>
          {/* <div className="dropdownItem" onClick={() => handleOptionClick("settings")}>
            <i className="fa fa-cog" aria-hidden="true"></i> Settings
          </div>
          <div className="dropdownItem" onClick={() => handleOptionClick("change-password")}>
            <i className="fa fa-key" aria-hidden="true"></i> Change Password
          </div> */}
          <div className="dropdownItem logout" onClick={() => handleOptionClick("logout")}>
            <i className="fa fa-sign-out" aria-hidden="true"></i> Logout
          </div>
        </div>
      )}
    </div>
  );
};

export default Account;